var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentPage.enName !== 'Details' && !_vm.isSelectMode && _vm.scrollTop < 60)?_c('div',{style:(_vm.navStyle),attrs:{"id":"nav"}},[_c('div',{staticClass:"page-name"},[_c('SearchInput')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }